import parseCookie from "./parseCookie";

export const SK_REDIRECT_COOKIE = "sk-redirect";
const cookieDomain = () =>
  typeof location !== "undefined" &&
  location.hostname.endsWith("smartkarma.com")
    ? " domain=.smartkarma.com;"
    : "";

export const setSkRedirectCookie = (authenticated?: {
  token?: string;
  email?: string;
}) => {
  if (typeof document === "undefined") return;

  try {
    const session =
      authenticated ||
      JSON.parse(
        decodeURIComponent(
          parseCookie(document.cookie)["ember_simple_auth-session"] || "{}"
        )
      )?.authenticated;

    if (!session?.token) return;

    const value = window.btoa(
      `Token token="${session.token}", email="${session.email}"`
    );

    document.cookie = `${SK_REDIRECT_COOKIE}=${value};${cookieDomain()} path=/`;
  } catch (error) {
    console.error("Failed to set sk-redirect cookie: ", error);
  }
};

export const clearSkRedirectCookie = () => {
  if (typeof document === "undefined") return;

  document.cookie = `${SK_REDIRECT_COOKIE}=; path=/; Max-Age=-99999999;`;
  document.cookie = `${SK_REDIRECT_COOKIE}=;${cookieDomain()} path=/; Max-Age=-99999999;`;
};
